import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import { _ParseAST } from '@angular/compiler';
import * as _ from 'underscore';
import { retry } from 'rxjs/operators';

/**
 * OVH mutualisé (val + prod) bloque les méthodes PATCH/PUT/DELETE au niveau
 * WAF (avant Apache/PHP), renvoyant une page HTML "403 Forbidden".
 * Workaround ISO : envoyer un POST avec le header X-HTTP-Method-Override
 * que le Slim MethodOverrideMiddleware convertit en la vraie méthode.
 * POST passe sans souci, Slim route comme si c'était un PATCH/PUT/DELETE.
 */
const METHOD_OVERRIDE_HEADERS = {
  PATCH: new HttpHeaders({ 'X-HTTP-Method-Override': 'PATCH' }),
  PUT: new HttpHeaders({ 'X-HTTP-Method-Override': 'PUT' }),
  DELETE: new HttpHeaders({ 'X-HTTP-Method-Override': 'DELETE' }),
};

@Injectable({
  providedIn: 'root'
})
export class RestService {
  selectedItemChange:EventEmitter<any>= new EventEmitter<any>()
  selectedItem;
  draftItem;
  endpoint;
  modelname;
  autoincrement:boolean = true;
  items;
  onClearFilter:EventEmitter<any>= new EventEmitter<any>();
  public filters:any = {};

  constructor(protected http: HttpClient) {
    this.init();
  }

  init() {}

  // ACTIONS
  setSelectedItem(selectedItem){
    this.selectedItem = selectedItem;
    this.selectedItemChange.emit(selectedItem);
  }

  refreshSelectedItem(id, callback?, force?,onErrorCallback?) {
    // console.log('refreshSelectedItem', id);

    if (
    force ||  !this.selectedItem ||
      (this.selectedItem && this.selectedItem.id != id)
    ) {
      this.getItem(id).subscribe((item) => {
        this.setSelectedItem(item);
        if(callback){
          callback();
        }
      },(error) => {
        if(onErrorCallback){
          onErrorCallback(error);
        }
      });
    }
  }

  // REST
  getItem(id): Observable<any> {

    if (typeof (id) == "object") id = id.id;

    return this.http.get<any>(
      environment.apiUrl + '/' + this.endpoint + '/' + id
    );
  }
  saveItem(item): Observable<any> {
    const form: any = {};
    form[this.modelname] = item;

    if (item.id && this.autoincrement) {
      // PATCH via POST + X-HTTP-Method-Override (OVH bloque PATCH direct)
      return this.http.post<any>(
        environment.apiUrl + '/' + this.endpoint + '/' + item.id,
        form,
        { headers: METHOD_OVERRIDE_HEADERS.PATCH }
      );
    } else {
      return this.http.post<any>(
        environment.apiUrl + '/' + this.endpoint,
        form
      );
    }
  }
  deleteItem(id?,where?): Observable<any> {

    let form:any = {};
    let params = "";
    if(where){
      form.where = encodeURI(JSON.stringify(where))
       params = this.convertParameters(form);
       params =  '?' + params
       console.log("deleteItem",params)
    }else{
      if(typeof (id) == "object")
      id = id.id
      params = '/' + id;
    }
    // DELETE via POST + X-HTTP-Method-Override (OVH bloque DELETE direct)
    return this.http.post<any>(
      environment.apiUrl + '/' + this.endpoint + params,
      null,
      { headers: METHOD_OVERRIDE_HEADERS.DELETE }
    );
  }

  getAttributes(): Observable<any> {
    return this.http.get<any>(
      environment.apiUrl + '/' + this.endpoint + '/attributes'
    );
  }

  getCount(filter?, group?,): Observable<any> {
    return this.getItems(filter,null,null,null,group,true)
  }
  getDistinct(columns?,filter?,order?): Observable<any> {
    return this.getItems(filter,order,null,null,columns.split(","),false,columns)
  }
  async chargeItems(filter?, order?, page?, limit?, group?,countOnly?,attributes?){
  return await this.getItems(filter,order,page,limit,group,countOnly,attributes).toPromise().then(res=>{
      this.items = res.items;
    }).catch(err => {
      console.error('chargeItems error:', err);
      this.items = [];
    })
  }
  getItems(filter?, order?, page?, limit?, group?,countOnly?,attributes?,withoutTotalCount?): Observable<any> {
    console.log('getItems',this.endpoint)
    /* Set conf depending on site. */
    page = page ? page : 1;
    limit = limit ? limit : 100;

    let form: any = {
      page,
      limit,
    };
    if (attributes) {
      form.attributes = attributes;
    }
    if (countOnly) {
      form.countOnly = countOnly;
    }
    if (withoutTotalCount) {
      form.withoutTotalCount = withoutTotalCount;
    }
    if (order) {
      form.order = order;
    }
    else if(order !== false)
    form.order = [['id', 'DESC']];
    if(form.order)
    form.order = encodeURI(JSON.stringify(form.order));
    // console.log(group);
    if (group) form.group = encodeURI(JSON.stringify(group));
    // form.where = {
    //   hidden: {
    //     "[ne]": 1,
    //   },
    // };
    if (filter) {
      // form.where = {
      //   "[and]": [form.where, filter],
      // };
      if (filter.includeFilter) {
        if (filter.where) {
          form.where = filter.where;
          form.where = encodeURI(JSON.stringify(form.where));
        }
        form.includeWhere = filter.includeFilter;
        form.includeWhere = encodeURI(JSON.stringify(form.includeWhere));
      }
      else if (filter.includeWhere) {
        if (filter.where) {
          form.where = filter.where;
          form.where = encodeURI(JSON.stringify(form.where));
        }
        form.includeWhere = filter.includeWhere;
        form.includeWhere = encodeURI(JSON.stringify(form.includeWhere));
      }
      else if (filter.include) {
        if (filter.where) {
          form.where = filter.where;
          form.where = encodeURI(JSON.stringify(form.where));
        }
        form.include = filter.include;
        form.include = encodeURI(JSON.stringify(form.include));
      }  else if (filter.where) {
        form.where = filter.where;
        form.where = encodeURI(JSON.stringify(form.where));
      } else {
        form.where = filter;
        form.where = encodeURI(JSON.stringify(form.where));
      }
      // console.log('where',form.where);
      // console.log('where JSON',JSON.stringify(form.where));
      // console.log('where JSON Stringify',form.where);
      // console.log('where JSON',decodeURI(form.where));
    }

    const params = this.convertParameters(form);
    // let params = '?loadOptions=' + encodeURI(JSON.stringify(loadOptions));
    //

    // get users from api
    return this.http.get<any>(
      environment.apiUrl + '/' + this.endpoint + '?' + params
    ).pipe(retry(1));
  }
  getItemsWithLoadOptions(loadOptions: any,column?,service?): Promise<any> {
    console.log('getItemsWithLoadOptions',loadOptions,column,service)
    // loadOptions
    // "skip",
    // "take",
    // "requireTotalCount",
    // "requireGroupCount",
    // "sort",
    // "filter",
    // "totalSummary",
    // "group",
    console.log('getItemsWithLoadOptions', loadOptions);
    const limit = loadOptions.isLoadingAll ? 1000000 : ( loadOptions.take ? loadOptions.take : 100000);
    const page = loadOptions.skip ? loadOptions.skip / limit + 1 : 1;

    let form: any = {
      page,
      limit,
    };
    // sort
    // form.order = [['id', 'DESC']];
    if(loadOptions.sort){
      form.order = []
      _.each(loadOptions.sort, sort =>{
        form.order.push( [sort.selector,(sort.desc? 'DESC': 'ASC')])
      })
      form.order = encodeURI(JSON.stringify(form.order));
    }
    else if(loadOptions.order){
      form.order = encodeURI(JSON.stringify(loadOptions.order));
    }

    // filter
    if (loadOptions.filter) {
      form.where = this.convertLoadOptionsFilters(loadOptions.filter);
    }

    if (loadOptions.includeWhere) {
      form.includeWhere = loadOptions.includeWhere;
      form.includeWhere = encodeURI(JSON.stringify(form.includeWhere));
    }


    if (loadOptions.include) {
      form.includeWhere = loadOptions.include;
      form.includeWhere = encodeURI(JSON.stringify(form.include));
    }


    // search
    if (
      loadOptions.searchValue &&
      loadOptions.searchOperation &&
      loadOptions.searchExpr
    ) {
      form = this.convertSearchFilters(loadOptions, form);
      console.log('form', form);
    }
    if (form.where) form.where = encodeURI(JSON.stringify(form.where));

    // dataField
    if(loadOptions.dataField){
      form.attributes = loadOptions.dataField
    }
    // group
    if(loadOptions.group){
      form.group = encodeURI(JSON.stringify([loadOptions.group[0].selector]));
      if(!form.order)
      form.order = encodeURI(JSON.stringify([[loadOptions.group[0].selector,'ASC']]));
    }


    const params = this.convertParameters(form);
    // let params = '?loadOptions=' + encodeURI(JSON.stringify(loadOptions));
    //

    // get users from api
    return this.http
      .get<any>(environment.apiUrl + '/' + this.endpoint + '?' + params)
      .toPromise()
      .then((data: any) => {


        if(loadOptions.dataField || loadOptions.group){
          data.items = _.map(data.items, item => {
            item.key = item[loadOptions.group[0].selector]
            // item.template = 'headerFilterTemplate'
            return item // item[loadOptions.dataField]
          })
        }
// console.log(data.items)

    // if(loadOptions.group){ // header filter?
    //             data.items = _.map(data.items, item => {

    //             console.log(typeof item[loadOptions.group[0].selector])
    //               return {key: item[loadOptions.group[0].selector]}
    //             })
    //             console.log(data.items)
    //             return {
    //               data: data.items}
    // }
    // else
    return {
          data: data.items,
          totalCount: data.totalCount,
          // summary: data.summary,
          // groupCount: data.groupCount
        };

        // if(loadOptions.group)
        // datas.key = [loadOptions.group[0].selector]

        //         console.log(datas)
        // return datas;
      })
      .catch((error) => {
        throw 'Data Loading Error';
      });
  }
  convertSearchFilters(loadOptions, form) {
    console.log('convertSearchFilters',loadOptions, form)
    if (form.where) {
      form.where = {
        '[and]': [form.where],
      };
    } else {
      form.where = {
        '[and]': [],
      };
    }
    let listExpr = loadOptions.searchExpr.split(',');

    // operator
    let operator = this.getOperator(loadOptions.searchOperation);
    // value
    let value = loadOptions.searchValue;
    let listWord = value.replace(/\s+/g,' ').trim().split(' ');
    if (operator == '[like]') value = '%' + value + '%';
    if (operator == '[startslike]'){ operator = '[like]'; value =  value + '%'; }
    if (operator == '[endslike]'){ operator = '[like]'; value = '%' + value; }
    if (operator == '[likecustom]'){
      operator = '[like]'; value =  value;
    }

    let listWhere: any = [];

    _.each(listExpr, (expr) => {
      // column
      let column = expr;
      let where = {'[and]':[]};
      _.each(listWord, word => {
        if (operator == '[like]') word = '%' + word + '%';
        where['[and]'].push(
          {
              [column]: {
                [operator]: word,
              },
            }
        )
      })
      // let where = {
      //   [column]: {
      //     [operator]: value,
      //   },
      // };
      listWhere.push(where);
    });
    console.log(listWhere);

    if (listWhere.length > 1) {
      listWhere = {
        '[or]': listWhere,
      };
      form.where['[and]'].push(listWhere);
    } else {
      form.where['[and]'] =  form.where['[and]'].concat(listWhere);
    }
    return form;
  }
  convertLoadOptionsFilters(filter: Array<any>) {
    let newFilter = {};

    if (filter.length) {
      if (typeof filter[0] == 'object') {
        // this level may contain operator
        let operator = '[and]';
        if(filter.length > 1){
         operator = this.getOperator(filter[1]);
        }

        newFilter[operator] = [];
        _.each(filter, (f) => {
          if (typeof f == 'object')
            newFilter[operator].push(this.convertLoadOptionsFilters(f));
        });
      } else {
        // this level contain search value and condition
        // console.log('this level contain search value and condition', filter);
        // 0 column
        let column = filter[0];
        // 1 operator
        let operator = this.getOperator(filter[1]);
        // 2 value
        let value = filter[2];

        // {'id': 'test'}
        // {'title': {'[Op.like]': '%test%'}
        if (operator == '[like]'){ operator = '[like]'; value = '%' + value + '%'; }
        if (operator == '[startslike]'){ operator = '[like]'; value =  value + '%'; }
        if (operator == '[endslike]'){ operator = '[like]'; value = '%' + value; }
        if (operator == '[likecustom]'){
          operator = '[like]'; value =  value;
        }

        return {
          [column]: {
            [operator]: value,
          },
        };
      }
    }

    // [
    // ["id", "=", "test", columnIndex: 0, filterValue: "test"],
    // "or",
    // ["title", "contains", "test", columnIndex: 1, filterValue: "test"],
    // ]

    // CONVERT TO

    // {
    //   '[Op.or]': [ {'id': 'test'},  {'title': {'[Op.like]': '%test%'}}]
    // }

    // 0 column
    // 1 operator
    // 2 value

    // contains =>  {'id': {'[Op.like]': '%'+ value+'%'}}

    return newFilter;
  }
  getOperator(operator) {
    if (operator == 'or') return '[or]';
    if (operator == 'and') return '[and]';
    if (operator == '=') return '[eq]';
    if (operator == '<>') return '[ne]';
    if (operator == 'contains') return '[like]';
    if (operator == 'endswith') return '[endslike]';
    if (operator == 'startswith') return '[startslike]';
    if (operator == '<') return '[lt]';
    if (operator == '<=') return '[lte]';
    if (operator == '>') return '[gt]';
    if (operator == '>=') return '[gte]';
    if (operator == 'in') return '[in]';

    console.log('getOperator - unknow operator', operator);
    return operator;
  }

  getFilters(modelname, filter?, order?, page?, limit?): Observable<any> {
    /* Set conf depending on site. */
    page = page ? page : 1;
    limit = limit ? limit : 100;

    let form: any = {
      page,
      limit,
    };
    form.order = [['id', 'DESC']];
    if (order) {
      form.order = order;
    }
    form.order = encodeURI(JSON.stringify(form.order));
    // form.where = {
    //   hidden: {
    //     "[ne]": 1,
    //   },
    // };
    if (filter) {
      // form.where = {
      //   "[and]": [form.where, filter],
      // };
      if (filter.includeFilter) {
        if (filter.where) {
          form.where = filter.where;
          form.where = encodeURI(JSON.stringify(form.where));
        }
        form.includeWhere = filter.includeFilter;
        form.includeWhere = encodeURI(JSON.stringify(form.includeWhere));
      } else if (filter.where) {
        form.where = filter.where;
        form.where = encodeURI(JSON.stringify(form.where));
      } else {
        form.where = filter;
        form.where = encodeURI(JSON.stringify(form.where));
      }
      // console.log('where',form.where);
      // console.log('where JSON',JSON.stringify(form.where));
      // console.log('where JSON Stringify',form.where);
      // console.log('where JSON',decodeURI(form.where));
    }

    const params = this.convertParameters(form);
    // let params = '?loadOptions=' + encodeURI(JSON.stringify(loadOptions));
    //

    // get users from api
    return this.http.get<any>(
      environment.apiUrl +
        '/' +
        this.endpoint +
        '/filters/' +
        modelname +
        '?' +
        params
    );
  }

  convertParameters(obj) {
    let str = '';
    for (let key in obj) {
      if (str != '') {
        str += '&';
      }
      str += key + '=' + encodeURIComponent(obj[key]);
    }
    return str;
  }
}
